<script lang="ts">
	import "../app.pcss";
	import FirebaseApp from "$lib/components/sveltefire/FirebaseApp.svelte";
	import Footer from "$lib/components/Footer.svelte";
	import NavBar from "$lib/components/NavBar.svelte";
	import Tracking from "$lib/components/Tracking.svelte";
	import { ModeWatcher } from "mode-watcher";
	import CaptureContactPopUp from "$lib/components/CaptureContactPopUp.svelte";
	import GeoLocation from "$lib/components/GeoLocation.svelte";
	import type { LayoutData } from "./$types";
	import { db as firestore, auth } from "$lib/client/firebase";
	import { page } from "$app/stores";
	import { Toaster } from "svelte-sonner";
	import Crisp from "$lib/components/Crisp.svelte";
	import OnlyBrowser from "$lib/components/OnlyBrowser.svelte";

	export let data: LayoutData;
	let hasScrolled = false;
	$: scrolled = hasScrolled ? 'scrolled' : '';  

	let childOpenPopUp: (type: string, force?: boolean) => void;
  
	function toggleAllMenuClosed () {
    const menus = document.querySelectorAll("#nucampmenu");
    menus.forEach((menu) => {
      const allDetails = menu?.querySelectorAll('details') || [];
      allDetails.forEach((detail) => {
        detail.removeAttribute('open');
      });
    });
  }

	function handleClick(event: MouseEvent) {
		const element = event.target as HTMLElement;
		if ($page.url.pathname.includes("/blog/")) anchorScrolling(element);
		toggleAllMenuClosed();
	}

	function onScroll(element: UIEvent) {
		const el = element.currentTarget as HTMLElement;
		if (el) {
			hasScrolled = el.scrollTop > 0;
			toggleAllMenuClosed();
		};
	}

	function anchorScrolling(element:any) {
		// Check if the clicked element is an <li> or a descendant of an <li>
		if (element) {
			if (element.tagName === 'LI' || element.closest('LI')) {
				if (element.parentElement && element.parentElement.id.includes("TOC")) {
					const anchor = element.parentElement.id.replace("TOC", "");
					const h2Element = document.getElementById(anchor);
					if (h2Element) {
						h2Element.scrollIntoView({ behavior: 'smooth' });
						setTimeout(() => childOpenPopUp("scroll", true), 1000);
					}
				}
			}
			if (element.tagName === 'SPAN' || element.closest('H2')) {  
				if (element.className.includes("TOCUP")) {
						const tocElement = document.getElementById("table-of-contents-h3");
						if (tocElement) {
							tocElement.scrollIntoView({ behavior: 'smooth' });
							setTimeout(() => childOpenPopUp("scroll", true), 1000)
						}
				}
			}
		}
	}

</script>
<svelte:head>
	<script type="module" src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"></script>
	<script nomodule src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js"></script>
	<link rel="preconnect" href="https://identitytoolkit.googleapis.com">
	<link rel="preconnect" href="https://firestore.googleapis.com">
	<link rel="preconnect" href="https://alb.reddit.com">
	<link rel="preconnect" href="https://www.googleadservices.com">
	<link rel="preconnect" href="https://analytics.tiktok.com">
	<link rel="preconnect" href="https://googleads.g.doubleclick.net">
	<link rel="preconnect" href="https://www.google.com">
	<link rel="preconnect" href="https://mautic.nucamp.co">
	<link rel="preconnect" href="https://alb.reddit.com">
	<link rel="preconnect" href="https://td.doubleclick.net">
	<link rel="preconnect" href="https://storage.googleapis.com">
	<link rel="preconnect" href="https://api.ipgeolocation.io">
</svelte:head>

<ModeWatcher />
<!-- <BugSnag /> -->
<Toaster richColors expand position="bottom-center"/>
<FirebaseApp {auth} {firestore}>
	<div class="flex flex-col h-screen">
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<div class="{scrolled}">
					<NavBar/>
			</div>
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-static-element-interactions -->
			<div id="nucampmain" class="flex-1 overflow-y-auto" on:scroll={(el) => onScroll(el) } on:click={(event) => handleClick(event)}>
					<div>
							<slot></slot>
					</div>
					{#await Promise.all([data.form, data.bootcamps])}
						<div></div>
					{:then [form, bootcamps]}
						<CaptureContactPopUp supForm={form} bootcamps={bootcamps} bind:openPopUp={childOpenPopUp}/>
					{/await}
					<div class="mt-20">
						<Footer/>
					</div>
			</div>
	</div>
	<OnlyBrowser noBots={true}>
		<Crisp />
		<Tracking />
		<GeoLocation />
	</OnlyBrowser>
</FirebaseApp>


<style lang="postcss">
	.scrolled {
		@apply shadow-md dark:shadow-base-200 dark:bg-base-200;
	}
</style>